import React from 'react';
import { CtaButton } from '../CtaButton';
import { AUTHOR_PHOTO_URL } from '../../data/offer';
export function Author() {
  return <section className="bg-white px-5 py-16 sm:py-20" aria-labelledby="author-title" data-id="element-69" data-mp="1htc6d8h2jhh9">
      <div className="mx-auto grid max-w-5xl items-start gap-8 md:grid-cols-[0.8fr_1.2fr] md:gap-12" data-id="element-70" data-mp="1whgqmgvrs125">
        <div className="mx-auto w-full max-w-sm overflow-hidden rounded-3xl bg-mist md:sticky md:top-8" data-id="element-71" data-mp="1rp6tafsbrypu">
          <img src={AUTHOR_PHOTO_URL} alt="Dr. Valeria Montes in her dental clinic" className="aspect-[4/5] w-full object-cover object-top" data-id="element-72" data-mp="25fse4a1caiqd" />
        </div>

        <div data-id="element-73" data-mp="2fg2qxtjgpo50">
          <p className="font-display text-sm font-extrabold uppercase text-electric" data-id="element-74" data-mp="2fft0y5yf3gzb">Meet the author</p>
          <h2 id="author-title" className="mt-1 font-display text-4xl font-black leading-none text-navy-950 sm:text-5xl" data-id="element-75" data-mp="2ahhp5pokaweg">
            Dr. Valeria Montes
          </h2>
          <p className="mt-3 font-display text-lg font-bold text-navy-800" data-id="element-76" data-mp="g2ov3v3budom">A message to my fellow dental professionals</p>

          <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80" data-id="element-77" data-mp="3gf5ok2hlm2cc">
            <p data-id="element-78" data-mp="3kfof7t7r92cy">Hello, I’m Dr. Valeria Montes.</p>
            <p data-id="element-79" data-mp="3kghjmnj8rfrx">
              When studying craniofacial growth and dentofacial orthopedics, it’s easy to encounter a large amount of
              information that doesn’t always feel connected.
            </p>
            <p data-id="element-80" data-mp="3u7u8d69qtptq">
              Growth patterns, skeletal maturity, facial relationships, orthopedic principles, and treatment
              considerations are closely related — yet they’re often studied as separate topics.
            </p>
            <p className="font-semibold text-navy-950" data-id="element-81" data-mp="bzmnrs0v2vnc">
              I believe a well-organized educational resource should help you see how those concepts fit together.
              That’s the approach behind MAXILLARY GROWTH BLUEPRINT™.
            </p>
            <p data-id="element-82" data-mp="2dtc9gqwup7uv">
              Throughout this collection, the emphasis is on visual explanations, structured assessment frameworks, and
              practical educational resources that make complex topics easier to review.
            </p>
            <p data-id="element-83" data-mp="3h2yfeltkltxe">
              Whether you’re expanding your knowledge of dentofacial orthopedics or revisiting concepts you’ve studied
              before, I hope this collection becomes a useful part of your professional learning library.
            </p>
          </div>
          <p className="mt-6 font-display text-2xl font-extrabold italic text-electric" data-id="element-84" data-mp="3q5g374oviumi">Dr. Valeria Montes</p>

          <div className="mt-8" data-id="element-85" data-mp="3vwnj5ecmn0j">
            <CtaButton label="Study with Dr. Montes' blueprint" data-id="element-86" data-mp="3utyz44i0wns" />
          </div>
        </div>
      </div>
    </section>;
}